import { useAuth } from '../store/auth';

export default function SettingsPage() {
  const { actor, tenant } = useAuth();
  return (
    <div className="p-8 max-w-3xl">
      <h1 className="text-2xl font-semibold mb-6">Settings</h1>
      <div className="card p-6 space-y-3 text-sm">
        <div className="grid grid-cols-2 gap-4">
          <div><div className="text-xs text-slate-500">Tenant</div><div>{tenant?.name ?? '—'}</div></div>
          <div><div className="text-xs text-slate-500">Slug</div><div className="font-mono">{tenant?.slug ?? '—'}</div></div>
          <div><div className="text-xs text-slate-500">Signed in as</div><div>{actor?.name} ({actor?.email})</div></div>
          <div><div className="text-xs text-slate-500">Actor type</div><div>{actor?.type} · {actor?.role}</div></div>
        </div>
      </div>
      <div className="card p-6 mt-4 text-sm">
        <div className="text-xs text-slate-500 uppercase mb-2">Brand</div>
        <p className="text-slate-600">Brand color and logo for your tenant's customer portal — coming soon as inline editor.</p>
      </div>
    </div>
  );
}
